import holidayJp from "@holiday-jp/holiday_jp";

// 日付文字列と日本の祝日を扱う純粋関数群。
// DOM にも Stimulus にも依存しないため、holiday-datepicker-controller から切り出している。
//
// タイムゾーンについて:
// ここで扱うのは時刻を持たない「暦の上の日付」なので、UTC への変換は一切行わない。
// 組み立ても読み出し (getFullYear / getMonth / getDate / getDay) もローカル時刻で統一し、
// 入れた年月日がそのまま読み戻せる状態を保つ。
// 管理画面の利用者はブラウザが JST のため、ローカル時刻がそのまま JST になる。
// 逆にここで JST を明示的に指定すると、組み立てと読み出しでタイムゾーンが食い違い、
// 日付が1日ずれる原因になる。
// (そもそも Date にタイムゾーンを渡す引数はなく、文字列に +09:00 を埋め込む方法も
//  読み出し側がローカル時刻のままなので解決にならない)

const SUNDAY = 0;
const SATURDAY = 6;

// 手入力を受け付けるため、区切り文字と桁数のゆれ (2026/9/1 など) も許容する
const DATE_PATTERN = /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/;

// 月・日を2桁に揃える (9 → '09')
const padZero = (number) => String(number).padStart(2, "0");

// 日付文字列を Date に変換する。
// 形式不正・存在しない日付 (2026-02-31 など) は null を返す。
export function parseDate(value) {
  const matched = DATE_PATTERN.exec(String(value ?? "").trim());
  if (!matched) return null;

  const [, year, month, day] = matched.map(Number);
  // 数値から組み立てればタイムゾーンによらず、入れた年月日をそのまま読み戻せる。
  // Date の月は 0 始まりなので -1 する。
  const date = new Date(year, month - 1, day);

  // Date は存在しない日付を黙って繰り上げる (2026-02-31 → 3/3、2026-09-32 → 10/2)。
  // 組み立てた Date が入力どおりに読み戻せるかで、有効な日付かを判定する。
  const isSameAsInput = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;

  return isSameAsInput ? date : null;
}

export function isSunday(date) {
  return date.getDay() === SUNDAY;
}

export function isSaturday(date) {
  return date.getDay() === SATURDAY;
}

// 祝日なら holiday_jp のデータ (name などを持つオブジェクト) を、そうでなければ null を返す。
// holidays は 'yyyy-MM-dd' をキーとするハッシュなので、between() で走査せず直接引く。
export function findHoliday(date) {
  return holidayJp.holidays[toIsoDate(date)] ?? null;
}

// 'yyyy-MM-dd' 形式へ整形する。入力欄の値と、祝日データを引くキーに使う。
// 注: toISOString() は UTC へ変換するため JST では前日の日付になる。ここでは使えない。
export function toIsoDate(date) {
  return `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}`;
}
